import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: 'notificationSettings',
      method: 'get',
      request: id => ({ url: apiRoutes.notificationSettings(id) }),
    },
  ])(ComposedComponent);
